import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { ModalService } from 'src/app/services/modal.service';
import { AlertService } from 'src/app/services/alert.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CatComunService } from 'src/app/modulos/catalogos-admin/services/cat-comun.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { AccionService } from '../../../services/accion.service';
import { Accion } from '../../../models/accion';
import { DatePipe } from '@angular/common';
import { validadorFechaIntervalo } from 'src/app/helpers/validator-form';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { UsuarioRedux } from 'src/app/models/usuario.model';
import * as FileSaver from 'file-saver';


@Component({
  selector: 'app-accion',
  templateUrl: './accion-objetivo.component.html',
  styleUrls: ['./accion-objetivo.component.css'],
})


export class AccionObjetivoComponent implements OnInit, OnDestroy {
  public modalAccionObjetivo: string = 'modalAccionRiesgoObjetivo';
  public modalCumpleAccionObjetivo: string = 'modalCumpleAccionObjetivo';
  public nameAppAccion = 'Cumplimiento de Acciones';
  public formAccion!: UntypedFormGroup;
  public formAccionCumple!: UntypedFormGroup;
  public currentUserRedux: UsuarioRedux = null;
  public submitted = false;
  private currentUser!: any;
  private ipAddress!: string;
  private buffer!: any;
  public dataAccion: any[] = [];
  private idDeleteRegister: number = 0;
  public selectItems: any[] = [];
  public idSprRiesgoInput!: any;
  public dataCatComun!: any;
  public idRecursivoTipoAccion = ConstantsCatalogosIdService.ID_COMUNES_TIPO_ACCION;
  public dataOut: any[] = [];
  private idSprUsuario: number = 0;
  public selectItems1: any[] = [];
  public pesoRestante: number = 100;
  public pesoEdit: any = 0;
  public pesoTotalEditado: any = 0;
  editPorcentajeTotal: boolean = true;
  editPorcentaje: boolean = false;
  public desahabilitarForm: boolean = false
  private idAccion: number = 0;
  public descripcion: any;
  public fechaComprometida: any;
  pipe = new DatePipe('en-US');
  hoy = new Date();
  public fechaCompletada: Date;
  public tipoAccion: any;
  public peso: any;
  public cumplimiento: any;
  public estado: any;
  bitesMaximoPdf = ConstantsCatalogosIdService.BIT_MAXIMO_PDF_CUMPLE_INDICADOR;
  readonly constant = ConstantsCatalogosIdService;
  public archivoCapturado: any[] = [];
  public nameRiesgo: any;
  public fechaIdentificacion: any;
  public fechaCierre: any;
  public planAnioSeleccionadoRedux: any = null;
  public idSprPlanAnio: number = 0;
  public idSprNivel: number = 0;

  fechaIniciObjetivo: any;
  fechaFinObjetivo: any;

  @ViewChild('myInput')
  myInputVariable: ElementRef;


  @Input() set data(dataOut) {
    this.idSprRiesgoInput = dataOut.idSprRiesgo;
    this.nameRiesgo = dataOut.nombre;
    this.fechaCierre = dataOut.fechaCierre;
    this.fechaIdentificacion = dataOut.fechaIdentificacion;
    this.initApp();
  }

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  isDtInitialized: boolean = false;

  constructor(
    private fb: FormBuilder,
    private accionService: AccionService,
    private alert: AlertService,
    private ip: IpPublicService,
    public modalAccion: ModalService,
    public modal: ModalService,
    private catalogoComunService: CatComunService,
    private sanitizer: DomSanitizer,
    public store: Store<AppState>
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.selectItems = [
      { value: '', label: 'Seleccione' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
    this.selectItems1 = [
      { value: 1, label: 'S' },
      { value: 2, label: 'N' },
    ];
  }

  ngOnInit(): void {
    this.getIpPublic();
    this.store.select('usuarioApp').subscribe((response) => {
      this.currentUserRedux = response.currentUser;
      this.idSprUsuario = response.currentUser.idSprUsuario;
    });
      this.store.select("globalApp").subscribe((response) => {
      this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
    });
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  initApp() {
    this.getDataAcciones();
    this.getDataCatalogoComun();
    this.setDataTable();
    this.setForm();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  get rolForm() {
    return this.formAccion.controls;
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  setForm() {
    this.formAccion = this.fb.group({
      idSprAccion: [],
      idSprRiesgo: [],
      descripcion: ['', [Validators.required]],
      idSprTipoAccion: ['', [Validators.required]],
      fechaComprometida: ['', [Validators.required, validadorFechaIntervalo(this.fechaIdentificacion, this.fechaCierre)]],
      fechaCompletada: [this.pipe.transform(this.hoy, 'yyyy-MM-dd')],
      peso: ['', [Validators.required]],
      cumplimiento: [0],
      estado: ['', [Validators.required]],
    });
    this.formAccionCumple = this.fb.group({
      idSprAccion: [],
      idSprRiesgo: [],
      cumplimiento: [0],
      respaldo: ['', [Validators.required]],
      estado: ['', [Validators.required]],
    });
  }

  getDataAcciones() {
    if (this.idSprRiesgoInput) {
      this.accionService.list('?idSprRiesgo=' + this.idSprRiesgoInput)
        .subscribe(resp => {
          this.dataAccion = resp;
          this.calculo(this.dataAccion, this.pesoRestante);// envia parametros para realizar el cálculo
        });
    }
  }

  getDataCatalogoComun() {
    this.catalogoComunService.list()
      .subscribe(resp => {
        this.dataCatComun = this.getDataDependiente(resp, this.idRecursivoTipoAccion);
      })
  }

  validacionFechas(fechaInicio: Date, fechaFin: Date) {
    let alerta1
    if (fechaInicio >= fechaFin) {
      alerta1 = this.alert.warning(
        '¡Atención!',
        'La fecha inicial no puede ser mayor a la fecha de cumplimiento'
      );
    }
  }

  validacionPeso(peso: any, pesoRestante: any, pesoTotalEdit: any) {
    if (this.formAccion.value.idSprAccion == null) {
      if (peso > pesoRestante) {
        this.alert.warning(
          '¡Atención!',
          'Peso seleccionado debe ser menor o igual que: ' + pesoRestante + '%',
        );
      } else if (peso == 0) {
        this.alert.warning(
          '¡Atención!',
          'Peso seleccionado no puede ser 0% ',
        );
      }
    } else {
      if (peso > pesoTotalEdit) {
        this.alert.warning(
          '¡Atención!',
          'Peso seleccionado debe ser menor o igual que: ' + pesoTotalEdit + '%',
        );
      }
      else if (peso == 0) {
        this.alert.warning(
          '¡Atención!',
          'Peso seleccionado no puede ser 0% ',
        );
      }
    }
  }

  onSubmit() {
    this.submitted = true;
    this.formAccion.value.usuario = this.idSprUsuario;
    this.formAccion.value.ip = this.ipAddress;
    this.formAccion.value.idSprRiesgo = this.idSprRiesgoInput;
    this.formAccion.value.descripcion = this.formAccion.value.descripcion;
    let fechaInicio = this.formAccion.value.fechaComprometida;
    let fechaFin = this.formAccion.value.fechaCompletada
    let peso = this.formAccion.value.peso;
    let pesoTotalEdit = this.pesoTotalEditado
    let pesoRestante = this.pesoRestante;
    this.validacionPeso(peso, pesoRestante, pesoTotalEdit)
    if (this.formAccion.valid) {
      if (this.formAccion.value.idSprAccion == null && (peso <= pesoRestante) && (peso != 0)) {
        this.accionService.create(this.formAccion.value).subscribe(
          (resp) => {
            this.getDataAcciones();
            this.modalAccion.closeId(this.modalAccionObjetivo);
            this.modalAccion.closeId(this.modalCumpleAccionObjetivo);
            this.getDataAcciones();
            this.getDataCatalogoComun();
            this.setDataTable();
            this.setForm();
            this.alert.createOk();
            this.editPorcentajeTotal = true;
            this.editPorcentaje = false;
          },
          (err) => {
            this.alert.createError();
          }
        );
      } else if ((peso <= pesoTotalEdit) && (peso != 0)) {
        this.formAccion.value.respaldo = this.nameFileGuardado;
        this.accionService.update(this.formAccion.value).subscribe(
          (resp) => {
            this.getDataAcciones();
            this.modalAccion.closeId(this.modalAccionObjetivo);
            this.closeModalCumplimientoIndicadorAdmin(this.modalCumpleAccionObjetivo)
            this.getDataAcciones();
            this.getDataCatalogoComun();
            this.setDataTable();
            this.alert.updateOk();
            this.editPorcentajeTotal = true;
            this.editPorcentaje = false;
          },
          (err) => {
            this.alert.updateError();
          }
        );
      }
    } else {
      return;
    }
  }

  cumpleAcciones() {
    if (this.formAccion.value.idSprAccion != null) {
      this.formAccion.value.respaldo = this.nameFileGuardado;
      this.formAccion.value.cumplimiento = 1;
      this.accionService.update(this.formAccion.value)
        .subscribe(
          (resp) => {
            this.initApp();
            this.closeModalCumplimientoIndicadorAdmin(this.modalCumpleAccionObjetivo)
            this.alert.updateOk(
              'Felicitaciones!',
              'Acción cumplida correctamente'
            );
            this.editPorcentajeTotal = true;
            this.editPorcentaje = false;
          },
          (err) => {
          }
        );
    }

  }

  editar(obj: Accion) {
    this.editPorcentajeTotal = false;
    this.editPorcentaje = true;
    this.openModalAccion();
    this.formAccion.patchValue({
      idSprAccion: obj.idSprAccion,
      idSprTipoAccion: obj.idSprTipoAccion,
      descripcion: obj.descripcion,
      fechaComprometida: obj.fechaComprometida,
      fechaCompletada: obj.fechaCompletada,
      peso: obj.peso,
      cumplimiento: obj.cumplimiento,
      respaldo: obj.respaldo,
      estado: obj.estado
    });
    this.pesoEdit = obj.peso;
    this.pesoTotalEditado = (this.pesoRestante + this.pesoEdit);
  }


  evaluacionAccion(obj: Accion) {
    this.submitted = true;
    let fechaComprometidaVal;
    let fechaActual;
    fechaComprometidaVal = obj.fechaComprometida;
    fechaActual = this.pipe.transform(this.hoy, 'yyyy-MM-dd');
    if (this.dataAccion.length >= 3) {
      if (this.pesoRestante <= 0) {
        if (fechaComprometidaVal >= fechaActual) {
          this.openModalAccionCumple();
        } else {
          this.alert.warning('¡Atención!', 'Fecha COMPROMETIDA fuera de vigencia')
        }
        this.formAccion.patchValue({
          idSprAccion: obj.idSprAccion,
          idSprTipoAccion: obj.idSprTipoAccion,
          descripcion: obj.descripcion,
          fechaComprometida: obj.fechaComprometida,
          fechaCompletada: obj.fechaCompletada,
          peso: obj.peso,
          cumplimiento: obj.cumplimiento,
          respaldo: obj.respaldo,
          estado: obj.estado
        });
        this.pesoEdit = obj.peso;
        this.pesoTotalEditado = (this.pesoRestante + this.pesoEdit);
        this.idAccion = obj.idSprAccion,
          this.descripcion = obj.descripcion,
          this.fechaComprometida = obj.fechaComprometida,
          this.fechaCompletada = obj.fechaCompletada,
          this.tipoAccion = obj.idSprTipoAccion,
          this.peso = obj.peso,
          this.cumplimiento = obj.cumplimiento,
          this.estado = obj.estado
        this.viewTipoAccion(obj.idSprTipoAccion)
      } else {
        this.alert.warning('¡Atención!',
          'La suma del peso de las acciones debe ser 100 %.')
      }
    } else {
      this.alert.warning('¡Atención!',
        'Ingrese tres acciones como mínimo')
      return;
    }
  }

  viewTipoAccion(idSprComun: number) {
    this.catalogoComunService.list(`${idSprComun}` )
      .subscribe(resp => {
        this.tipoAccion = resp.nombre;
      })
  }


  delete(idRegister: number) {
    this.idDeleteRegister = idRegister;
    this.modalAccion.open('deleteAccionObjetivo');
  }

  confirmDelete() {
    if (this.idDeleteRegister > 0) {
      this.accionService.delete(
        {
          "idSprAccion": this.idDeleteRegister,
          "usuario": this.idSprUsuario,
          "delLog": "S",
          "ip": this.ipAddress
        }
      )
        .subscribe(resp => {
          this.modalAccion.closeId('deleteAccionObjetivo')
          this.getDataAcciones();
          this.alert.deleteOk();
          this.editPorcentajeTotal = true;
          this.editPorcentaje = false;
        }, (err) => {
          this.alert.deleteError();
        });
    }
  }


  getDataDependiente(dataObj: any, spr_idSprComun: any = null) {
    let dependientes: any = [];
    dataObj.forEach((row: any) => {
      if (row.spr_idSprComun == spr_idSprComun) {
        dependientes.push(
          {
            idSprComun: row.idSprComun,
            nombre: row.nombre,
            descripcion: row.descripcion,
            spr_idSprComun: row.spr_idSprComun,
            estado: row.estado,
          });
      }
    });
    return dependientes;
  }

  calculo(dataAcciones: any, pesoRestante: number) {
    let ponderacionTotalActividad: any = 100;
    let pesoAterior: any = 0;
    let pesoActual: any;
    let ponderacionRestante: any = 100;
    for (let i = 0; i < dataAcciones.length; i++) {
      pesoActual = dataAcciones[i].peso
      pesoAterior = (pesoActual + pesoAterior);
      ponderacionRestante = (ponderacionTotalActividad - pesoAterior);
    }
    this.pesoRestante = ponderacionRestante
  }

  /* ################################################# */
  /*******función subir archivo *********************/
  /* ################################################# */
  public archivos: any = [];
  public nameFileGuardado: any;
  public previsualizacion: string;

  capturarFile(event): any {
    this.submitted = false;
    const archivoCapturado = event.target.files[0];
    this.extraerBase64(archivoCapturado).then((imagen: any) => {
      this.previsualizacion = imagen.base;

    }
    );
    this.archivos.push(archivoCapturado);

  }

  extraerBase64 = async ($event) => new Promise((resolve, reject) => {
    try {
      const unsafeIng = window.URL.createObjectURL($event);
      const image = this.sanitizer.bypassSecurityTrustUrl(unsafeIng);
      const reader = new FileReader();
      reader.readAsDataURL($event);
      reader.onload = () => {
        resolve({
          //blob: $event,
          //image,
          base: reader.result
        });
      };
      reader.onerror = error => {
        resolve({
          //blob: $event,
          //image,
          base: null
        });
      };
    } catch (error) {
      return null;
    }
  })

  visualizarPdf(archivo: string) {
    this.accionService.download(archivo).subscribe({
      next: (data) => {
        const byteCharacters = atob(data.file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
           const fileURL = URL.createObjectURL(blob);
           //window.open(fileURL, '_black');
           FileSaver.saveAs(blob, archivo +'.pdf');
      },
      error: () => {
      }
    })
  }

  subirArchivo(): any {
    if (this.archivos.length != 0) {
      try {
        const formularioDeDatos = new FormData();
        this.archivos.forEach(archivo => {
          formularioDeDatos.append('file', archivo);
        })
        this.accionService.postArchivo(formularioDeDatos, this.idAccion).subscribe(responseNamePdf => {
          this.nameFileGuardado = responseNamePdf.filename;
          this.cumpleAcciones()
        })
      } catch (error) {
      }
    } else {
      this.alert.warning('¡Atención!', 'No existe documento de soporte')
      return;
    }
  }

  onResetFormCumplimientoIndicadorAdmin() {
    this.submitted = false;
    this.formAccion.reset();
  }
  closeModalCumplimientoIndicadorAdmin(idModal: string = '') {
    this.modal.closeId(idModal);
    this.reset();
    this.onResetFormCumplimientoIndicadorAdmin();
  }

  reset() {
    this.myInputVariable.nativeElement.value = "";
    this.archivos = []
  }

  /**********************FIN DE CARGA DE ARCHIVOS *****************/

  /********************CONTADOR DE CARACTER*******************/
  public contador = 0
  onKey(event) {
    let maxLength = 500;
    let strLength = event.target.value.length;
    let charRemain = (maxLength - strLength);
    if (charRemain < 0) {
      document.getElementById("contador").innerHTML = '<span style="color: red;"> Ha superado el límite de ' + maxLength + ' characters</span>';
    } else {
      document.getElementById("contador").innerHTML = charRemain + ' caracteres restantes';
    }
  }
  /*************************************************************/

  openModalAccion() {
    this.modalAccion.open(this.modalAccionObjetivo);
    this.onResetForm();
    this.setForm();
    this.getDataAcciones();
  }

  openModalAccionCumple() {
    this.modalAccion.open(this.modalCumpleAccionObjetivo);
    this.onResetForm();
    this.setForm();
  }

  closeModal() {
    this.modalAccion.closeId(this.modalAccionObjetivo)
    this.setDataTable();
    this.setForm();
    this.editPorcentajeTotal = true;
    this.editPorcentaje = false;
  }

  onResetForm() {
    this.submitted = false;
    this.formAccion.reset();
  }

}
